import { render, staticRenderFns } from "./EditProductForm.vue?vue&type=template&id=3fde22fc&scoped=true&"
import script from "./EditProductForm.vue?vue&type=script&lang=js&"
export * from "./EditProductForm.vue?vue&type=script&lang=js&"
import style0 from "./EditProductForm.vue?vue&type=style&index=0&id=3fde22fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fde22fc",
  null
  
)

export default component.exports